import clsx from 'clsx';
import { TestId } from '../../enums/test';
import { SeparatorProps } from './index.types';

function Separator({ className = '' }: SeparatorProps) {
    return <div className={clsx('w-full h-px bg-charcoal-100', className)} data-testid={TestId.SEPARATOR} />;
}

export default Separator;
